<template>
  <v-tab-item :key="1" :value="'tab-1'" class="pa-4">
    <v-select
      dense
      :items="saleLevels"
      item-text="tooltips"
      item-value="value"
      label="Level Sales"
      placeholder="Chọn Level Sales"
      v-model="level"
    ></v-select>
    <v-textarea
      full-width
      name="notes"
      label="Ghi Chú"
      placeholder="Nhập Ghi Chú"
      v-model="notes"
      style="font-size: 1em !important"
      dense
    ></v-textarea>
    <v-card-actions>
      <div class="flex-grow-1"></div>
      <v-btn depressed small right color="error" @click="cancel()">Cancel</v-btn>
      <v-btn depressed small color="primary" style="margin: 0 20px" @click="save()">Save</v-btn>
    </v-card-actions>
  </v-tab-item>
</template>

<script>
export default {
  props: {
    contact: {
      type: [Object],
      required: true,
      default: () => {}
    }
  },
  data: () => ({
    valid: true,
    name: '',
    level: '',
    notes: '',
    saleLevels: [
      { value: 'L1A', tooltips: 'L1A - Đúng số điện thoại' },
      { value: 'L1B', tooltips: 'L1B - Chưa nghe máy' },
      { value: 'L1C', tooltips: 'L1C - Sai số điện thoại' },
      { value: 'L2A', tooltips: 'L2A - Đúng đối tượng - cần chăm sóc lại' },
      { value: 'L2C', tooltips: 'L2C - Sai đối tượng' },
      { value: 'L3A', tooltips: 'L3A - Có nhu cầu đã trao đổi' },
      { value: 'L3B', tooltips: 'L3B - Cần chăm sóc lại' },
      { value: 'L3C', tooltips: 'L3C - Chưa có nhu cầu' },
      { value: 'L7A', tooltips: 'L7A - Đồng ý đến học trải nghiệm' },
      { value: 'L7B', tooltips: 'L7B - Không đến học trải nghiệm' },
      { value: 'L7C', tooltips: 'L7C - Đã học Trải nghiệm - Cần chốt sale' },
      { value: 'L7D', tooltips: 'L7D - Đã học trải nghiệm - Không muốn học' },
      { value: 'L8A', tooltips: 'L8A - Đã xác nhận học' },
      { value: 'L8B', tooltips: 'L8B - Đã thanh toán' },
      { value: 'L8B2', tooltips: 'L8B2 - Đã thanh toán 1 phần' },
      { value: 'L8C', tooltips: 'L8C - Đúng số điện thoại' },
      { value: 'L8C', tooltips: 'L8C - Đã huỷ' }
    ]
  }),

  methods: {
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    save () {
      this.$emit('save', {
        notes: this.notes,
        level: this.level
      })
    },
    cancel () {
      this.notes = this.contact.notes
      this.level = this.contact.level
      this.$emit('cancel')
    }
  },
  watch: {
    contact (contact) {
      this.notes = this.contact.notes
      this.level = this.contact.level
    }
  }
}
</script>

<style scoped>
</style>
